import { PROJECT_SHIVA_TAG, BILLING_UPSELL_DISCOUNT } from 'App/featuresFlags';
import { useGetIsFreePlan, useGetTags } from 'domains/Auth/hooks';
import useGetStorePaymentDiscount from 'domains/Auth/hooks/useGetStorePaymentDiscount';
import { useGetStoreDiscountsQuery } from 'domains/Billing/Checkout/CheckoutApi/checkoutApi';
import { BillingUpsellDiscount } from './BillingUpsellDiscount';
import { ExpiredStoreAdBar } from './ExpiredStoreAdBar';
import { PostUpsellPaymentInvitation } from './PostUpsellPaymentInvitation';
import { StorePaymentDiscount } from './StorePaymentDiscount';
import { useTopAdBar } from './useTopAdBar';
import { useExpirationBanner } from '../ExpirationBanner/useExpirationBanner';

export function TopAdBar() {
  const { showExpirationBanner, isExpired } = useExpirationBanner();
  const { isFreePlan, isTrial } = useGetIsFreePlan();
  const storePaymentDiscount = useGetStorePaymentDiscount();
  const tags = useGetTags();
  const { isShowTopAdBar } = useTopAdBar();
  const isShivaProject = tags.includes(PROJECT_SHIVA_TAG);
  const isBillingUpsellDiscount = tags.includes(BILLING_UPSELL_DISCOUNT);
  const { data: storeDiscounts } = useGetStoreDiscountsQuery(undefined, {
    skip: !isBillingUpsellDiscount,
  });

  if (!isShowTopAdBar) return null;

  if (isBillingUpsellDiscount) {
    const upsellDiscount = storeDiscounts?.find(
      (discount) => discount.description === BILLING_UPSELL_DISCOUNT,
    );
    if (upsellDiscount && upsellDiscount.expires_at) {
      const expirationDate = new Date(upsellDiscount.expires_at);
      if (expirationDate.getTime() > Date.now()) {
        return <BillingUpsellDiscount expirationDate={expirationDate} />;
      }
    }
  }

  if (!isTrial && isExpired && showExpirationBanner) {
    return <ExpiredStoreAdBar />;
  }

  if (storePaymentDiscount) {
    return (
      <StorePaymentDiscount
        percentage={storePaymentDiscount.percentage}
        expirationDate={new Date(storePaymentDiscount.expirationDate)}
      />
    );
  }

  if (isTrial && !isFreePlan && !isShivaProject) {
    return <PostUpsellPaymentInvitation />;
  }

  return null;
}
